import { useQuery } from "react-query";
import { getSubscriptions, getSubscriptionSubjectsInClass } from "../services/school/student/getSubscriptions";
import { PagedRequestType } from "../types/PagedResults";
import { Key_subscriptionSubjectsInClass } from "../utils/constants";

export const useGetSubscriptionSubjectsInClassQuery = (pagedRequest?: PagedRequestType, options: any = null) => {
  return useQuery([Key_subscriptionSubjectsInClass, JSON.stringify(pagedRequest)], () => getSubscriptionSubjectsInClass(pagedRequest), options ? { ...options } : {});
};
